var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.FilterFacility()
      }
    }
  }, [_vm._v("Facility (" + _vm._s(_vm.setSVCCountAll) + ")\r\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    attrs: {
      "size": "sm",
      "options": _vm.srList,
      "name": "SrId",
      "placeholder": "Select SR",
      "selected-option": _vm.srItemObj
    },
    on: {
      "select": _vm.FilterselectSR
    },
    model: {
      value: (_vm.SrId),
      callback: function($$v) {
        _vm.SrId = $$v
      },
      expression: "SrId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SrId')),
      expression: "errors.has('SrId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SrId')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tripDayflag == 1),
      expression: "tripDayflag == 1"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please close existing trip from SR app.!\r\n                    ")]), _vm._v(" "), (_vm.tripTitle == 'Continue trip' && _vm.IsSRNeedTrip) ? _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v(" Trip Created Date :\r\n                        " + _vm._s(_vm.tripCreatedDate) + " ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "success",
      "disabled": !_vm.startTripFlag
    },
    on: {
      "click": function($event) {
        return _vm.OpenStartTripModal()
      }
    }
  }, [_vm._v("Start Trip\r\n                    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "info",
      "disabled": _vm.SrId == '',
      "title": "Print Runsheet"
    },
    on: {
      "click": function($event) {
        return _vm.OpenPrintShipmentModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  })])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.NonAllocationRsn),
      callback: function($$v) {
        _vm.NonAllocationRsn = $$v
      },
      expression: "NonAllocationRsn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.TitleName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-top": "3px"
    }
  }, [_vm._v("Please select the reason of\r\n                                        non-allocation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Reason:")]), _vm._v(" "), _c('b-input-group', [_c('basic-select', {
    attrs: {
      "name": "Reason",
      "placeholder": "Select",
      "options": _vm.ReasonList,
      "selected-option": _vm.ReasonObj
    },
    on: {
      "select": _vm.selectReason
    },
    model: {
      value: (_vm.Reason),
      callback: function($$v) {
        _vm.Reason = $$v
      },
      expression: "Reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitNonAllocationRsn()
      }
    }
  }, [_vm._v("Submit")]), _vm._v("     \r\n                                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_vm._v("close")])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.SrName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm"
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorOpenKM),
      expression: "errorOpenKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorOpenKM))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == '' || _vm.openKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.PrintShipmentModal == true) ? _c('b-modal', {
    staticClass: "PrintShipmentModal",
    attrs: {
      "size": "lg",
      "id": "PrintShipmentModal",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.PrintShipmentModal),
      callback: function($$v) {
        _vm.PrintShipmentModal = $$v
      },
      expression: "PrintShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Print Shiment for Delivery")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePrintShipmentModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('label', [_vm._v("SR Name:")]), _vm._v("  \r\n                                        "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.SrName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Created Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "batchCreatedDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.batchCreatedDate),
      callback: function($$v) {
        _vm.batchCreatedDate = $$v
      },
      expression: "batchCreatedDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.batchCreatedDate == ''
    },
    on: {
      "click": function($event) {
        return _vm.GetShipmentPrintdetails()
      }
    }
  }, [_vm._v("Print\r\n                                            Runsheet")]), _vm._v("    \r\n                                        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ResetPrintShipmentModal()
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowPrintTable),
      expression: "ShowPrintTable"
    }],
    staticClass: "col=md-12 mt-4"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadBatch,
      "text": "Please wait to batch table get open..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadBatch = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadPDF,
      "text": "Please wait.... PDF is being generating.!"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadPDF = $event
      }
    }
  }), _vm._v(" "), _c('load-table-template', {
    attrs: {
      "columns": _vm.PrintShipmentsColumns,
      "showShipmentsList": _vm.PrintShipmentsList,
      "BatchID": true,
      "ShipmentsNum": true,
      "srList": _vm.srList,
      "EnableHyperLink": _vm.EnableHyperLink
    },
    on: {
      "printShipment": _vm.PrintShipment,
      "ExportCSV": _vm.exportCSVOfShippingIDS
    }
  })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.startTripModelFlag == true) ? _c('b-modal', {
    staticClass: "startTripModelFlag",
    attrs: {
      "id": "startTripModelFlag",
      "size": "lg",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startTripModelFlag),
      callback: function($$v) {
        _vm.startTripModelFlag = $$v
      },
      expression: "startTripModelFlag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Start Trip")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelStartTrip()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "border-right": "1px solid"
    }
  }, [_c('h5', [_vm._v("Trip not started yet.")]), _vm._v(" "), _vm._l((_vm.DeliveryUserIDs), function(col, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(col))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "name": "SrId",
      "placeholder": "Select SR",
      "selected-option": _vm.srItemObj
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.SrId),
      callback: function($$v) {
        _vm.SrId = $$v
      },
      expression: "SrId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SrId')),
      expression: "errors.has('SrId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The SrId field is required. ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tripDayflag == 1),
      expression: "tripDayflag == 1"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please\r\n                                                close existing trip\r\n                                                from SR\r\n                                                app.! ")]), _vm._v(" "), (_vm.tripTitle == 'Continue trip' && _vm.IsSRNeedTrip) ? _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("\r\n                                                Trip Created Date : " + _vm._s(_vm.tripCreatedDate) + "\r\n                                            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mt-4"
  }, [(_vm.TopReset) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), (_vm.IsSRNeedTrip) ? _c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.startTripFlag == false || _vm.tripDayflag == 1 || _vm.tripDateFlag == true
    },
    on: {
      "click": function($event) {
        return _vm.startTrip()
      }
    }
  }, [_vm._v("\r\n                                            " + _vm._s(_vm.tripTitle))]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.SRSelectingloader
    },
    on: {
      "update:active": function($event) {
        _vm.SRSelectingloader = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.tripTitle == 'Start Trip' && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && tripTitle=='Start Trip' && IsSRNeedTrip"
    }],
    staticClass: "form-group row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-primary1 mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('bike')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" Bike\r\n                                            ")]), _vm._v("    \r\n                                            "), _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('vehicle')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Vehicle\r\n                                            ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType && IsSRNeedTrip"
    }],
    staticClass: "form-group row mt-2"
  }, [((_vm.vehicleType == 'bike' && _vm.srVehicleList.length == 0) || _vm.isVehicleReplaced == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleNo),
      expression: "vehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('vehicleNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "vehicleNo"
    },
    domProps: {
      "value": (_vm.vehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleNo),
      expression: "errVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg:\r\n                                                MH 12 HA\r\n                                                5678 / MHU\r\n                                                123)")])], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srVehicleList,
      "selected-option": _vm.vehicleNoItemObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Open KM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleOpenKM),
      expression: "vehicleOpenKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Open KM",
      "name": "vehicleOpenKM"
    },
    domProps: {
      "value": (_vm.vehicleOpenKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleOpenKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleKm),
      expression: "errVehicleKm"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleKm))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vehicleType == 'bike' && _vm.srVehicleList.length > 0),
      expression: "vehicleType=='bike' && srVehicleList.length>0"
    }],
    staticClass: "col-md-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isVehicleReplaceCheck($event)
      }
    },
    model: {
      value: (_vm.isVehicleReplacedCheck),
      callback: function($$v) {
        _vm.isVehicleReplacedCheck = $$v
      },
      expression: "isVehicleReplacedCheck"
    }
  }, [_vm._v("Is Vehicle Replaced?\r\n                                        ")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startAllocationFlag || !_vm.IsSRNeedTrip),
      expression: "startAllocationFlag || !IsSRNeedTrip"
    }],
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConfirmLoad,
      "text": "Please wait confirm trip is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirmLoad = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelStartTrip()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.SrId !== '') ? _c('button', {
    staticClass: "btn btn-danger ml-2",
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType && _vm.IsSRNeedTrip),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType && IsSRNeedTrip"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.vehicleNo == '' || _vm.vehicleOpenKM == ''
    },
    on: {
      "click": function($event) {
        return _vm.startAllocation(true)
      }
    }
  }, [_vm._v("Start\r\n                            Allocation")])])])])]) : _vm._e(), _vm._v(" "), (_vm.startModelMPS == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startModelMPS),
      callback: function($$v) {
        _vm.startModelMPS = $$v
      },
      expression: "startModelMPS"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.MPSTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelMPS(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "sty": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "border-right": "1px solid",
      "color": "black"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.MPSSrNameTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSNote))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSAddress))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelMPS(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getSameMPSGroupShipmentsRVP2(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_vm._v("ok")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.shipmentInfoFlag),
      callback: function($$v) {
        _vm.shipmentInfoFlag = $$v
      },
      expression: "shipmentInfoFlag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Information")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseshipmentInfoFlag()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("SR Tab")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P0:")]), _vm._v(" Escalation shipments which are sub-set of ‘reattempt shipments’ for a given rider")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P1:")]), _vm._v(" All shipments with aging >=1 day & eligible for today’s allocation and sub-set of ‘reattempt shipments’ for a given rider")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P2:")]), _vm._v(" All shipments excluding P0 & P1 above and sub-set of reattempt shipments")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Facility Tab")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P0:")]), _vm._v(" All the facility level escalation shipments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P1:")]), _vm._v("All shipments with aging >=1 day & eligible for today’s allocation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_c('b', [_vm._v("P2:")]), _vm._v("All shipments excluding P0 & P1 above.")])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.morePendingRVPShipmentsModel),
      callback: function($$v) {
        _vm.morePendingRVPShipmentsModel = $$v
      },
      expression: "morePendingRVPShipmentsModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.sameCustomerTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRvpShipmentsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.IsrvpMPSAllocation) ? _c('h5', [_vm._v("Below Shipments are from same customer, Please allocate them to same SR. ")]) : _c('h5', [_vm._v(_vm._s(_vm.mpsErrorLabel) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.preMPSValidationCheck()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.continueloader
    },
    on: {
      "update:active": function($event) {
        _vm.continueloader = $event
      }
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeRvpShipmentsModel()
      }
    }
  }, [_vm._v("\r\n                                                Cancel")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-responsive",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAllMoreShip),
      expression: "sAllMoreShip"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAllMoreShip) ? _vm._i(_vm.sAllMoreShip, "") > -1 : (_vm.sAllMoreShip)
    },
    on: {
      "click": _vm.selectAllMoreRVPShipments,
      "change": function($event) {
        var $$a = _vm.sAllMoreShip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAllMoreShip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAllMoreShip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAllMoreShip = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("MPS ID")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("PDD Date")]), _vm._v(" "), _c('th', [_vm._v("Pending Since")]), _vm._v(" "), _c('th', [_vm._v("No.of ReAttempt")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Cluster ID")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.suggestRVPArrayList), function(row, index) {
    return _c('tr', {
      style: (row.NotificationStatus == 'SuperEscalation' ? _vm.styleObjectsp : (row.NotificationStatus == 'Escalation') ? _vm.styleObjectE : ''),
      attrs: {
        "id": 'rvpTrMr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickupsMore),
        expression: "selectedPickupsMore"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickupsMore' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickupsMore) ? _vm._i(_vm.selectedPickupsMore, row.ShippingId) > -1 : (_vm.selectedPickupsMore)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickupsMore,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickupsMore = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickupsMore = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickupsMore = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.MultiShipmentGroupID) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingSince))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ServiceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.subclustername))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CIMr' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.showUnallocatedList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])])], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.vehiclePopup),
      callback: function($$v) {
        _vm.vehiclePopup = $$v
      },
      expression: "vehiclePopup"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("EBN Error Shipments.")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.ebnDataLoader
    },
    on: {
      "update:active": function($event) {
        _vm.ebnDataLoader = $event
      }
    }
  }, [_vm._v("Please wait, data is being processing..")]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.SaveEBNData('form1')
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "0%"
    }
  }, [(_vm.errorRvpAllocation || _vm.successRvpAllocation) ? _c('div', {
    staticClass: "col-md-12 mt-2",
    staticStyle: {
      "font-weight": "bold",
      "margin-bottom": "20px"
    }
  }, [_vm._l((_vm.errorRvpAllocationErrorArrobj), function(singleRvpError, index) {
    return _c('b-alert', {
      key: index,
      staticStyle: {
        "padding": "0%",
        "margin": "0%"
      },
      attrs: {
        "show": _vm.dismissCountDown,
        "dismissible": "",
        "fade": "",
        "variant": "danger"
      },
      on: {
        "dismiss-count-down": _vm.countDownChanged
      }
    }, [_vm._v("\r\n                                            " + _vm._s(singleRvpError.shippingId) + " :- " + _vm._s(singleRvpError.message) + "\r\n                                        ")])
  }), _vm._v(" "), (_vm.successRvpAllocation || _vm.dismissCountDownSuccess > 0) ? _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\r\n                                            " + _vm._s(_vm.successRvpAllocation) + "\r\n                                        ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Below shipments are belongs to EBN, Please enter\r\n                                            ebn vehicle number..!!")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-4"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default tablehead"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.EBNshippingData), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(item.shippingId))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehicleNumbers[item.shippingId]),
        expression: "vehicleNumbers[item.shippingId]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          regex: _vm.vehicleNoRegExp
        }),
        expression: "{ required: true, regex: vehicleNoRegExp }"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has('VehicleNo_' + item.shippingId)
      },
      attrs: {
        "type": "text",
        "name": 'VehicleNo_' + item.shippingId
      },
      domProps: {
        "value": (_vm.vehicleNumbers[item.shippingId])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.vehicleNumbers, item.shippingId, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('form1.VehicleNo_' + item.shippingId)),
        expression: "errors.has('form1.VehicleNo_' + item.shippingId)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("The VehicleNo_" + _vm._s(item.shippingId) + " field format is invalid.")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-5",
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v("     \r\n                                        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closevehiclePopup
    }
  }, [_vm._v("close")])])])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.srBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, [_vm._l((_vm.srPriorities), function(priority) {
    return (_vm.getFlagVisibility('SR', priority)) ? _c('b-button', {
      key: priority,
      staticClass: "col-sm-2 m-1",
      attrs: {
        "size": "sm",
        "variant": _vm.getActiveVariant('SR', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsr', priority)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(priority) + " (" + _vm._s(_vm.getCount('SR', priority)) + ")\r\n                ")]) : _vm._e()
  }), _vm._v(" "), _c('b-button', {
    staticClass: "col-sm-1 ml-1 pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('a', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.shipmentInfo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    }
  })])])], 2) : _vm._e(), _vm._v(" "), (_vm.svcBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, [_vm._l((_vm.svcPriorities), function(priority) {
    return (_vm.getFlagVisibility('SVC', priority)) ? _c('b-button', {
      key: priority,
      staticClass: "col-sm-2 m-1",
      attrs: {
        "size": "sm",
        "variant": _vm.getActiveVariant('SVC', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsvc', priority)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(priority) + " (" + _vm._s(_vm.getCount('SVC', priority)) + ")\r\n                ")]) : _vm._e()
  }), _vm._v(" "), _c('b-button', {
    staticClass: "col-sm-1 ml-1 pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('a', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.shipmentInfo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    }
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 pt-2"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px"
    },
    on: {
      "click": _vm.RefreshShipment
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "row col-sm-6"
  }, [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPendingShipment),
      expression: "searchPendingShipment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchPendingShipment",
      "type": "text",
      "name": "searchPendingShipment",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchPendingShipment)
    },
    on: {
      "change": _vm.filteredTableData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPendingShipment = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.errorRvpAllocation) ? _c('div', {
    staticClass: "row mt-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, _vm._l((_vm.errorRvpAllocationErrorArrobj), function(singleRvpError, index) {
    return _c('b-alert', {
      key: index,
      staticStyle: {
        "padding": "0%",
        "margin": "0%"
      },
      attrs: {
        "show": _vm.dismissCountDown,
        "dismissible": "",
        "fade": "",
        "variant": "danger"
      },
      on: {
        "dismiss-count-down": _vm.countDownChanged
      }
    }, [_vm._v("\r\n                " + _vm._s(singleRvpError.shippingId) + " :- " + _vm._s(singleRvpError.message) + "\r\n            ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.successRvpAllocation) ? _c('div', {
    staticClass: "row mt-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [(_vm.successRvpAllocation || _vm.dismissCountDownSuccess > 0) ? _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.successRvpAllocation) + "\r\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 table-responsive",
    staticStyle: {
      "border": "1px solid #e0ddd9",
      "overflow-y": "auto",
      "max-height": "400px",
      "position": "relative"
    }
  }, [(_vm.CountLoading) ? _c('div', {
    staticClass: "loader-overlay d-flex flex-column align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-progress', {
    attrs: {
      "value": _vm.progressCount,
      "max": "100",
      "height": "20px",
      "animated": "",
      "striped": "",
      "variant": "success"
    }
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table-responsive table-hover table-bordered tbl datatables",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    }
  }, [_c('thead', [_c('tr', [(_vm.IsCheckbox) ? _c('th', {
    staticClass: "text-center tableheader sticky-header"
  }, [(_vm.IsCheckbox && _vm.checkboxDisabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllCheckbox),
      expression: "selectAllCheckbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllCheckbox) ? _vm._i(_vm.selectAllCheckbox, null) > -1 : (_vm.selectAllCheckbox)
    },
    on: {
      "click": _vm.selectAllItems,
      "change": function($event) {
        var $$a = _vm.selectAllCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllCheckbox = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.IsCheckbox && !_vm.checkboxDisabled) ? _c('span', [_vm._v("Select")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.PendingColumns), function(col, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center tableheader sticky-header sticky-last"
    }, [_vm._v("\r\n                    " + _vm._s(col.label) + "\r\n                ")])
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader sticky-header",
    staticStyle: {
      "position": "sticky",
      "background": "#e0ddd9"
    }
  }, [_vm._v("\r\n                    Action")])], 2)]), _vm._v(" "), _c('tbody', [(!_vm.tableDataLoader && !_vm.showUnallocatedListFilter.length) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": 12
    }
  }, [_c('h1', [_vm._v("No Record Found")])])]) : _vm._l((_vm.showUnallocatedListFilter), function(row, index) {
    return _c('tr', {
      key: index
    }, [(_vm.IsCheckbox) ? _c('td', {
      staticClass: "text-center sticky-first",
      staticStyle: {
        "min-width": "10px"
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('b-badge', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(row.Bucket))])], 1), _vm._v(" "), (row.TotalAttemptCount > 0) ? _c('div', {
      staticClass: "col-sm-4"
    }, [_c('b-badge', {
      attrs: {
        "size": "sm",
        "variant": "warning"
      }
    }, [_vm._v("A" + _vm._s(row.TotalAttemptCount))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItemsOnChild),
        expression: "selectedItemsOnChild"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.selectedItemsOnChild) ? _vm._i(_vm.selectedItemsOnChild, row) > -1 : (_vm.selectedItemsOnChild)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItemsOnChild,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItemsOnChild = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItemsOnChild = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItemsOnChild = $$c
          }
        }, function($event) {
          return _vm.selectedItemdata($event, row)
        }]
      }
    })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.PendingColumns), function(col, colIndex) {
      return _c('td', {
        key: colIndex,
        staticClass: "text-center",
        style: (col.size)
      }, [(col.label === 'AWB|MPS') ? _c('span', [_vm._v("\r\n                            " + _vm._s(row[col.key[0]]) + " "), _c('br'), _vm._v(_vm._s(row[col.key[1]]) + "\r\n                            "), (row[col.key[2]] > 0) ? _c('span', {
        staticStyle: {
          "background": "yellow"
        }
      }, [_c('br'), _vm._v(_vm._s(row[col.key[2]]) + " items\r\n                            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (col.type === 'text') ? _c('span', [_vm._v(_vm._s(row[col.key]))]) : _vm._e(), _vm._v(" "), (col.type === 'link') ? _c('a', {
        staticClass: "clickable",
        on: {
          "click": function($event) {
            return col.action(row.id)
          }
        }
      }, [_c('u', [_c('font', {
        attrs: {
          "color": "blue"
        }
      }, [_vm._v("View")])], 1)]) : _vm._e(), _vm._v(" "), (col.type === 'button') ? _c('b-button', {
        staticClass: "btn btn-primary",
        staticStyle: {
          "cursor": "pointer",
          "padding": "4px"
        },
        on: {
          "click": function($event) {
            return col.action(row.id)
          }
        }
      }, [(col.btnicon) ? _c('i', {
        class: col.btnicon
      }) : _vm._e(), _vm._v("\r\n                            " + _vm._s(col.btnlabel) + "\r\n                        ")]) : _vm._e()], 1)
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "30px"
      },
      style: ({
        zIndex: _vm.selectedRow === row ? _vm.lastColumnZIndex : 1,
        position: 'sticky',
        right: 0
      })
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.handleSelectClick(row)
        }
      }
    }, [_c('basic-select', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "options": [{
          value: '',
          text: 'Select SR'
        } ].concat( _vm.srList),
        "name": "row.Srid",
        "placeholder": "Select SR",
        "selected-option": row.srItemObj
      },
      on: {
        "select": function($event) {
          return _vm.selectTableSR($event, row, 'Inside')
        }
      },
      model: {
        value: (row.Srid),
        callback: function($$v) {
          _vm.$set(row, "Srid", $$v)
        },
        expression: "row.Srid"
      }
    })], 1), _vm._v(" "), (_vm.shouldShow(row)) ? _c('span', {
      staticStyle: {
        "background-color": "yellow"
      }
    }, [_vm._v(_vm._s(row.DeliveryUserNameLastAttempted))]) : _vm._e()])], 2)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("SR Selected for " + _vm._s(this.selectedCount) + " Shipment")]), _vm._v(" "), (_vm.selectedItemsOnChild.length > 0) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('basic-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "options": [{
        value: '',
        text: 'Select SR'
      } ].concat( _vm.srList),
      "name": "outsideSrId",
      "placeholder": "Select SR",
      "selected-option": _vm.outsidesrItemObj
    },
    on: {
      "select": function($event) {
        return _vm.selectTableSR($event, '', 'outside')
      }
    },
    model: {
      value: (_vm.outsideSrId),
      callback: function($$v) {
        _vm.outsideSrId = $$v
      },
      expression: "outsideSrId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedItemsOnChild.length == 0 && _vm.outsideSrId !== '') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-button', {
    staticClass: "btn btn-block",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        return _vm.allocatePickupShipment()
      }
    }
  }, [_vm._v("\r\n                    Assign")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedCount > 0 && _vm.outsideSrId === '' && _vm.selectedItemsOnChild.length == 0) ? _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-block",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        return _vm.allocatePickupShipment()
      }
    }
  }, [_vm._v("\r\n                    Assign")])], 1) : _vm._e()])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-2"
  }, [_c('b', [_vm._v("loading...")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06915e4c","hasScoped":true}!./src/views/components/newallocationpagev2/Reverseallocationv2/Reverseallocationv2.html
// module id = 1526
// module chunks = 1